import React from 'react';
import quote from '../../../assets/icons/quote.svg'
import people1 from '../../../assets/images/people1.png'
import people2 from '../../../assets/images/people2.png'
import people3 from '../../../assets/images/people3.png'
import Review from '../Review/Review';

const Testimonial = () => {
    const reviews = [
        {
            _id:1,
            name:'Dr.Younus',
            location:'california',
            description:'Excellent doctor!!!Very thorough and caring. Im terribly afraid of the dentist and she,s very sensitive to that and goes the extra mile to make you feel comfortable. Love her!',
            img:people1,
        },
        {
            _id:2,
            name:'Zoe.Byden',
            location:'california',
            description:'Excellent doctor!!!Very thorough and caring. Im terribly afraid of the dentist and she,s very sensitive to that and goes the extra mile to make you feel comfortable. Love her!',
            img:people2,
        },
        {
            _id:3,
            name:'Mr.Bean',
            location:'california',
            description:'Excellent doctor!!!Very thorough and caring. Im terribly afraid of the dentist and she,s very sensitive to that and goes the extra mile to make you feel comfortable. Love her!',
            img:people3,
        },
    ]
    return (
        <section className='mx-auto'>
            <div className='flex justify-between'>
                <div className="mx-3">
                    <p className='text-info text-2xl my-3  font-semibold'>Testimonial</p>
                    <h1 className=' lg:text-3xl font-semibold'>What Our Patients Says</h1>
                </div>
                <div className="">
                    <figure>
                        <img src={quote} className="w-28 lg:w-48" alt="" />
                    </figure>
                </div>
            </div>
            <div className=" lg:grid grid-cols-3">
                {
                    reviews.map(review=><Review
                    key={review._id}
                    review={review}
                    >

                    </Review>)
                }

            </div>
        </section>
    );
};

export default Testimonial;